module.exports = '<svg width="40" height="32" viewBox="0 0 40 32"><path d="M23.959 11.993h13.938c1.104 0 2.064.9 2.064 2.004v4c0 1.104-.956 1.996-2.064 1.996H23.959v9.365c0 2.48-1.752 3.36-3.752 2L1.465 18.476c-2-1.36-1.924-3.6.036-4.961L20.215.633c1.952-1.36 3.744-.48 3.744 2v9.357z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/left-3.js
// module id = 1214
// module chunks = 14